import React, { useContext } from "react";
import { DataContext } from "../../Context/DataContext";
import NoData from "../../NewComponents/NoData";
import { searchClientAlgolia } from "../../firebase.config";
import { InstantSearch } from "react-instantsearch-hooks-web";
import AccountQuotesComponent from "./QuotesComponent";
import Loader from "../../NewComponents/Loader";

const Quotes = ({ windowSize }) => {

  const { userData } = useContext(DataContext);

  if(!userData){
    return <div className="container mx-auto w-full h-dvh flex items-center justify-center">
              <Loader />
            </div>
  }

  return (
    <>
      {/* <TopBar /> */}
    <InstantSearch searchClient={searchClientAlgolia} indexName="quotes" >
      <AccountQuotesComponent windowSize={windowSize}/>
      </InstantSearch>
    </>
  );
};

export default Quotes;
